import { createSelector } from 'reselect';
import { getProfileData } from './getProfileData';
import { getProfileMedia } from './getProfileMedia';

export const getVenueCoverSources = createSelector(
	getProfileData,
	getProfileMedia,
	(data, media) => {
		const rooms = data.room.map((r) => {
			const roomImgs = (media?.room || {})[r.id] || [];
			if (roomImgs.length) {
				return {
					id: `room_${r.id}`,
					title: `${t('Фото зала')}: ${r.name}`,
				};
			}
			return null;
		});
		const albums = data.album.map((a) => {
			return {
				id: a.id,
				title: a.title,
			};
		});

		return [...albums, ...rooms.filter((r) => !!r)];
	},
);
